// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"1205":"css/admin-app.6672","1358":"css/app.6672"}[chunkId] + ".css";
};